<template>
  <v-row>
    <v-card-title> Produtos </v-card-title>
    <v-spacer></v-spacer>
    <v-col class="d-flex" cols="12" sm="3">
      <v-select
        class="mt-3"
        label="Empresa"
        outlined
        dense
        flat
        height="10px"
        :items="getEnterprises.data"
        item-value="id"
        item-text="fantasyName"
        v-model="component.enterpriseId"
        return-object
      ></v-select>
    </v-col>
    <!-- <v-btn
      class="mr-2 mt-6"
      color="success"
      v-if="component.permission.Cadastrar"
      @click="
        () => {
          executeAlterAddDialog();
        }
      "
      >Adicionar</v-btn -->
    >
  </v-row>
</template>

<script>
import { GET_ALL_ENTERPRISE } from "./../../../store/actions/enterprise";
import { mapGetters } from "vuex";

export default {
  props: {
    component: Object,
  },

  data: () => ({
    selectValue: Object(),
  }),

  methods: {
    // active() {
    //   this.component.addDialog = !this.component.addDialog;
    // },
    executeAlterAddDialog() {
      this.component.AlterAddDialog();
    },
    async getAll() {
      await this.$store.dispatch(GET_ALL_ENTERPRISE, {
        page: 1, limit: 10, paginate:true 
      });
    },
  },
  created() {
    this.getAll();
  },

  computed: {
    ...mapGetters(["getEnterprises"]),
  },

  watch: {
    getEnterprises(val) {
      this.component.enterpriseId = val.data[0].id;
    },
  },
};
</script>
